"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePromotionsTexts = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var next_intl_1 = require("next-intl");
var config_1 = require("./config");
var useGetTextByKey_1 = require("./utils/useGetTextByKey");
var usePromotionsTexts = function () {
    var _a;
    var lang = (0, next_intl_1.useLocale)();
    var prevLang = (0, react_1.useRef)(lang);
    var _b = (0, useQuery_1.useQuery)({
        path: keys_1.TEXTS_PROMOTIONS,
        payload: {
            category: config_1.TEXT_CATEGORIES.PROMOTIONS,
            lang: lang.toLowerCase(),
        },
        onErrorRetry: function () { return false; },
    }), data = _b.data, isLoading = _b.isLoading, mutate = _b.mutate;
    (0, react_1.useEffect)(function () {
        if (prevLang.current !== lang) {
            mutate();
            prevLang.current = lang;
        }
    }, [lang, mutate]);
    return (0, useGetTextByKey_1.useGetTextByKey)(isLoading, (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.text);
};
exports.usePromotionsTexts = usePromotionsTexts;
